import './AdminAuthIps.scss'
import React, {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {
    Button,
    Col,
    Descriptions,
    Form,
    Icon,
    Input,
    Modal,
    notification,
    Row,
    Select,
    Spin,
    Switch,
    Tooltip,
    Upload,
    message
} from 'antd'

import {UsersService} from '../../services'
import {getUserIpPromise, saveParamsPromise, uploadLogoClientePromise, uploadFooterPortalPromise} from './promises'
import {getParamsPromise} from '../AdminParams/promises'
import ImageResources from '../../layouts/commonComponent/components/ExternalResources/ImageResources'

import apiConfig from "../../config/api";
import axios from 'axios'

const AdminAuthIps = (props) => {
    const {t} = useTranslation()
    const {Option} = Select
    const {currentUser, form, handleUnsavedChanges} = props
    const {getFieldDecorator} = form

    const [usersList, setUsersList] = useState([])
    const [selectedUserId, setSelectedUserId] = useState('')
    const [ipsList, setIpsList] = useState([])
    const [userIpIsLoading, setUserIpIsLoading] = useState(false)
    const [isSaving, setIsSaving] = useState(false)
    const [isLoading, setIsLoading] = useState(true)

    /*Password params states*/
    const [expirationAllow, setExpirationAllow] = useState("N");
    const [expirationValue, setExpirationValue] = useState(0);
    const [notificationValue, setNotificationValue] = useState(0);
    const [isGlobalPasswordValidation, setIsGlobalPasswordValidation] = useState([]);

    const [logos, setLogos] = useState([
        { id: currentUser.cliente.id, name: 'Logo matriz', file: null }
    ])

    const [uploadingLogoId, setUploadingLogoId] = useState(null)
    const [downloadingLogoId, setDownloadingLogoId] = useState(null)
    const [refreshKey, setRefreshKey] = useState(Date.now())

    const [banner, setBanner] = useState({
        id: 'banner_portal',
        name: '',
        file: null
    })

    const [uploadingBanner, setUploadingBanner] = useState(false)
    const [downloadingBanner, setDownloadingBanner] = useState(false)
    const [deletingBanner, setDeletingBanner] = useState(false)
    const [hasBanner, setHasBanner] = useState(false)
    
    const { confirm } = Modal;

    useEffect(() => {
        handleDefaultUser()
        handleGetUsersList()
        handleGetParams()
        initializeLogos()
        checkBannerExists()
    }, [])

    useEffect(() => {
        initializeLogos()
    }, [currentUser])

    const initializeLogos = () => {
        const clienteName = currentUser && currentUser.cliente && currentUser.cliente.name 
            ? currentUser.cliente.name 
            : 'matriz'
        const logosArray = [
            { 
                id: currentUser.cliente.id, 
                name: `Logo ${clienteName} (matriz)`, 
                file: null,
                type: 'matriz',
                clientId: currentUser && currentUser.cliente ? currentUser.cliente.id : null
            }
        ]

        if ( currentUser?.cliente?.outsourcer && currentUser?.cliente?.clientes && Array.isArray(currentUser?.cliente?.clientes)) {
            currentUser.cliente.clientes.forEach((cliente, index) => {
                const clienteName = cliente.name || cliente.nombre || currentUser.cliente.clientes[index].id
                logosArray.push({
                    id: currentUser.cliente.clientes[index].id,
                    name: `Logo ${clienteName}`,
                    file: null,
                    type: 'filial',
                    subclienteId: cliente.id || null
                })
            })
        }

        setLogos(logosArray)
    }

    const getLogoUrl = (logo) => {
        if (logo.type === 'matriz' && logo.clientId) {
            return `/getImageClient?clientId=${logo.clientId}&t=${refreshKey}`
        } else if (logo.type === 'filial' && logo.subclienteId) {
            return `/getImageClientUser/0/${logo.subclienteId}?t=${refreshKey}`
        }
        return null
    }

    const handleGetParams = async () => {

        const params = await getParamsPromise()
        await setIpsList(params.ips)
        setIsLoading(false)

        const passwordSettings = parseInt(params.passwordSettings.globalPasswordSetting,10) > 0;
        setIsGlobalPasswordValidation(passwordSettings)

        if (passwordSettings) {
            const expirationAllow = params.passwordSettings.expirationAllow === null ? "N" : params.passwordSettings.expirationAllow
            const expirationParam = params.passwordSettings.expirationTime === null ? 0 : params.passwordSettings.expirationTime
            const notificationParam = params.passwordSettings.notificationTime === null ? 0 :  params.passwordSettings.notificationTime

            let clientValidatePwd = (expirationParam && expirationParam[0] !== "0");
            handleSwitchChange(clientValidatePwd, false)
            setExpirationAllow(expirationAllow);
            setExpirationValue(expirationParam);
            setNotificationValue(notificationParam)
        }
    }

    const handleGetUsersList = async () => {
        const u = await UsersService.read()
        setUsersList(u.data.records)
    }

    const checkBannerExists = () => {
        if (!currentUser?.cliente?.id) {
            setHasBanner(false)
            return
        }
        
        const bannerUrl = apiConfig.url + `/portal/getLogoFooterPortal/${currentUser.cliente.id}`
        axios.head(bannerUrl)
            .then(response => {
                const contentLength = parseInt(response.headers['content-length'] || '0', 10)
                setHasBanner(contentLength > 500)
            })
            .catch(() => setHasBanner(false))
    }

    const handleDefaultUser = async () => {
        if (currentUser.cliente.oficialCto !== null) {
            setSelectedUserId(currentUser.cliente.oficialCto.id)
        }
    }

    const handleUserChange = async (id) => {
        setSelectedUserId(id)
        handleUnsavedChanges(true);
    }

    const handleAddIp = async (e) => {
        let ip = document.getElementsByClassName('user-ip')[0].value

        if (ip !== '') {
            setIpsList(oldIpsList => [...oldIpsList, ip])
            form.setFieldsValue({userIp: ''})
            handleUnsavedChanges(true);
        }
    }

    const handleRemoveIp = async (index) => {
        const newIpsList = ipsList.slice()
        newIpsList.splice(index, 1)
        setIpsList(newIpsList)
        handleUnsavedChanges(true);
    }

    const handleGetUserIp = async () => {
        setUserIpIsLoading(true)
        const userIp = await getUserIpPromise()
        await form.setFieldsValue({ userIp })
        setUserIpIsLoading(false)
    }

    const isNumeric = (value) => {
        return /^[0-9]*$/.test(value);
    };

    const handleSaveParams = async () => {

        // Validación adicional para expirationValue
        if (expirationValue === 0 && expirationAllow !== "N") {
            confirm({
                title: t("messages.aml.params.confirmation.title"),
                content: t("messages.aml.params.zero.expiration"),
                okType: 'primary',
                okText: t("messages.aml.si"),
                cancelText: t("messages.aml.no"),
                onOk() {
                    setExpirationValue(0)
                    setExpirationAllow("N");
                    }
            });
            return;

        }else {
            await setIsSaving(true)
            confirm({
                title: t("messages.aml.params.confirmation.title"),
                content: t("messages.aml.params.confirmation.message"),
                okType: 'primary',
                okText: t("messages.aml.si") + ", guardar cambios",
                cancelText: t("messages.aml.no"),
                onOk() {
                    const params = {}
                    params.ipsList = ipsList
                    if (isGlobalPasswordValidation) {
                        if (expirationAllow === "Y" && (!isNumeric(expirationValue) || !isNumeric(notificationValue))) {
                            notification.error({
                                message: t('messages.aml.params.error.input.message'),
                                description: t('messages.aml.valid.values')
                            })
                            setIsSaving(false)
                            return;
                        }

                        params.expirationAllow = expirationAllow
                        params.expirationPwd = expirationValue
                        params.notificationPwd = notificationValue
                    }

                    params.ofCto = selectedUserId;
                    saveParams(params);
                },
                onCancel() {
                    setIsSaving(false)
                }
            });
        }
    }

    const saveParams = async (params) => {
        await saveParamsPromise(params).then((response) =>{
            if(response.success){
                if(response.data === "OK"){
                    handleUnsavedChanges(false)
                    notification.success({
                        message: t('messages.aml.notifications.succesfulOperation'),
                        description: 'Actualizado exitosamente.'
                    })
                }else{
                    notification.error({
                        message: t('messages.aml.notifications.anErrorOcurred'),
                        description: t('Error al guardar datos.')
                    })
                }
            }
        });
        setIsSaving(false)
    }

    const handleSwitchChange = (checked, userChange) => {
        if(userChange) {
            handleUnsavedChanges(true);
        }
        setExpirationAllow(checked ? "Y" : "N");
    };

    const handleExpirationInputChange = (e) => {
        let currentValue = e.target.value.trim().replace(/\D/g, '');
        let newValue = parseInt(currentValue, 10);

        if (isNaN(newValue) || newValue < 0) {
            newValue = 0;
        } else if (newValue > 9999) {
            newValue = 9999;
        }
        setExpirationValue(newValue)
        handleUnsavedChanges(true);
    };

    const handleNotificationInputChange = (e) => {
        let currentValue = e.target.value.trim().replace(/\D/g, '');
        let newValue = parseInt(currentValue, 10);

        if (isNaN(newValue) || newValue < 0) {
            newValue = 0;
        } else if (newValue > 9999) {
            newValue = 9999;
        }
        setNotificationValue(newValue)
        handleUnsavedChanges(true);
    };

    const handleDownloadLogo = (logo) => {
        const url = getLogoUrl(logo)
        if (!url) {
            message.error('No se pudo obtener la URL del logo')
            return
        }

        setDownloadingLogoId(logo.id)
        const finalUrl = apiConfig.url + url

        axios.get(finalUrl, {
            responseType: 'blob'
        })
        .then(response => {
            const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', `${logo.name}.png`); //aquí se setea el formato de descarga y el nombre del archivo
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            console.error('Error descargando logo:', error)
            message.error('Error al descargar el logo')
        })
        .finally(() => {
            setDownloadingLogoId(null)
        })
    }

    const handleUploadLogo = (logo, file) => {
        const isPng = file.type === 'image/png'
        const isJpeg = file.type === 'image/jpeg' || file.type === 'image/jpg'
        
        if (!isPng && !isJpeg) {
            message.error('Solo se permiten archivos PNG, JPEG o JPG')
            return false
        }

        const maxSize = 50 * 1024 // 30KB en bytes
        if (file.size > maxSize) {
            message.error(`El tamaño máximo del archivo es 50KB. Tamaño actual: ${(file.size / 1024).toFixed(2)}KB`)
            return false
        }

        // Activar el estado de carga para este logo específico
        setUploadingLogoId(logo.id)

        // Crear FormData y proceder con la subida
        const formData = new FormData()
        formData.append('type', logo.type)
        formData.append('id', logo.id)
        formData.append('file', file)

        uploadLogoClientePromise(formData)
            .then((response) => {
                if (response.success) {
                    message.success(`${logo.name} cargado correctamente`)
                    if (handleUnsavedChanges) {
                        handleUnsavedChanges(true)
                    }
                } else {
                    notification.error({
                        message: t('messages.aml.notifications.anErrorOcurred'),
                        description: 'Error al subir el logo.'
                    })
                }
            })
            .catch((error) => {
                const errorMessage = error?.data || (typeof error === 'string' ? error : 'Error al subir el logo.')
                notification.error({
                    message: t('messages.aml.notifications.anErrorOcurred'),
                    description: errorMessage
                })
            })
            .finally(() => {
                initializeLogos()
                setRefreshKey(Date.now())
                setUploadingLogoId(null)
            })

        return false // Prevenir subida automática
    }

    const uploadProps = (logo) => ({
        beforeUpload: (file) => handleUploadLogo(logo, file),
        showUploadList: false,
        accept: '.png,.jpg,.jpeg'
    })

    const handleDownloadBanner = () => {
        setDownloadingBanner(true)
        const bannerUrl = `/portal/getLogoFooterPortal/${currentUser.cliente.id}?t=${refreshKey}` 
        const finalUrl = apiConfig.url + bannerUrl

        axios.get(finalUrl, {
            responseType: 'blob'
        })
        .then(response => {
            const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', 'banner_portal.png'); 
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            console.error('Error descargando banner:', error)
            message.error('Error al descargar el banner')
        })
        .finally(() => {
            setDownloadingBanner(false)
        })
    }

    const handleUploadBanner = (file) => {
        const isPng = file.type === 'image/png'
        const isJpeg = file.type === 'image/jpeg' || file.type === 'image/jpg'
        
        if (!isPng && !isJpeg) {
            message.error('Solo se permiten archivos PNG, JPEG o JPG')
            return false
        }

        const maxSize = 150 * 1024 // 150KB en bytes
        if (file.size > maxSize) {
            message.error(`El tamaño máximo del archivo es 150KB. Tamaño actual: ${(file.size / 1024).toFixed(2)}KB`)
            return false
        }

        // validar 900x120px
        const reader = new FileReader()
        reader.onload = (e) => {
            const img = new Image()
            img.onload = () => {
                const requiredWidth = 900
                const requiredHeight = 120
                
                if (img.width !== requiredWidth || img.height !== requiredHeight) {
                    message.error(`Las dimensiones del banner deben ser exactamente ${requiredWidth}x${requiredHeight} píxeles. Dimensiones actuales: ${img.width}x${img.height} píxeles`)
                    return
                }

                //empieza la subida
                setUploadingBanner(true)

                const formData = new FormData()
                formData.append('file', file)

                uploadFooterPortalPromise(formData)
                    .then((response) => {
                        if (response.success) {
                            message.success('Banner actualizado correctamente')
                            setBanner({
                                ...banner,
                                file: file
                            })
                            setHasBanner(true)
                            setRefreshKey(Date.now())
                            if (handleUnsavedChanges) {
                                handleUnsavedChanges(true)
                            }
                        } else {
                            notification.error({
                                message: t('messages.aml.notifications.anErrorOcurred'),
                                description: 'Error al subir el banner.'
                            })
                        }
                    })
                    .catch((error) => {
                        const errorMessage = error?.data || (typeof error === 'string' ? error : 'Error al subir el banner.')
                        notification.error({
                            message: t('messages.aml.notifications.anErrorOcurred'),
                            description: errorMessage
                        })
                    })
                    .finally(() => {
                        setUploadingBanner(false)
                    })
            }
            img.onerror = () => {
                message.error('Error al leer las dimensiones de la imagen')
            }
            img.src = e.target.result
        }
        reader.onerror = () => {
            message.error('Error al leer el archivo')
        }
        reader.readAsDataURL(file)

        return false //return para prevenir la subida automática
    }

    const uploadBannerProps = {
        beforeUpload: (file) => handleUploadBanner(file),
        showUploadList: false,
        accept: '.png,.jpg,.jpeg'
    }

    const handleDeleteBanner = () => {
        confirm({
            title: 'Eliminar Banner',
            content: '¿Está seguro que desea eliminar el banner?',
            okText: 'Sí, eliminar',
            cancelText: 'Cancelar',
            okType: 'danger',
            onOk() {
                setDeletingBanner(true)

                const formData = new FormData()
                formData.append('file', null)

                uploadFooterPortalPromise(formData)
                    .then((response) => {
                        if (response.success) {
                            message.success('Banner eliminado correctamente')
                            setBanner({
                                ...banner,
                                file: null
                            })
                            setHasBanner(false)
                            setRefreshKey(Date.now())
                            if (handleUnsavedChanges) {
                                handleUnsavedChanges(true)
                            }
                        } else {
                            notification.error({
                                message: t('messages.aml.notifications.anErrorOcurred'),
                                description: 'Error al eliminar el banner.'
                            })
                        }
                    })
                    .catch((error) => {
                        const errorMessage = error?.data || (typeof error === 'string' ? error : 'Error al eliminar el banner.')
                        notification.error({
                            message: t('messages.aml.notifications.anErrorOcurred'),
                            description: errorMessage
                        })
                    })
                    .finally(() => {
                        setDeletingBanner(false)
                    })
            }
        })
    }


    return (

        <div className="admin-auth-ips block">
            <br/>

            {!isLoading ?
                <>
                    <div className="admin-users">
                        <div className="tools-area">
                            {currentUser.type !== 'AUDIT' &&
                                <Button className="send-button"
                                        icon={isSaving ? 'loading' : 'check'}
                                        type="primary"
                                        onClick={handleSaveParams}>
                                    Guardar cambios
                                </Button>
                            }
                        </div>
                    </div>

                    { isGlobalPasswordValidation &&  currentUser.type === 'SADMIN' &&
                        <Descriptions column={1} layout="horizontal" bordered>
                            <Descriptions.Item label={<b>{t("messages.aml.params.password.control")}</b>}>
                                     <Row>
                                        <Col span={9}>
                                            <label> {t("messages.aml.params.password.expiration.time")} </label>
                                        </Col>
                                        <Col span={11}>
                                            <Input className='expiration_input'
                                                   style={{textAlign: 'center', fontWeight: 'bold', color: 'back'}}
                                                   placeholder={expirationValue}
                                                   value={expirationValue}
                                                   disabled={expirationAllow !== "Y"}
                                                   type={"number"}
                                                   onChange={handleExpirationInputChange}
                                            />
                                        </Col>
                                        <Col span={4} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <Tooltip title={t("messages.aml.params.password.Disable")}>
                                            <Switch
                                                className='expiration_switch'
                                                checked={expirationAllow === "Y"}
                                                onChange={(e) => {handleSwitchChange(e, true)}}
                                            />
                                        </Tooltip>
                                        </Col>
                                    </Row>
                                <br/>
                                     <Col span={9}>
                                        <label> {t("messages.aml.params.password.notification.days")} </label>
                                    </Col>
                                    <Col span={11}>
                                        <Input
                                            className='notification_input'
                                            style={{textAlign: 'center', fontWeight: 'bold'}}
                                            placeholder={notificationValue}
                                            value={notificationValue}
                                            type={"number"}
                                            disabled={expirationAllow !== "Y"}
                                            onChange={handleNotificationInputChange}
                                        />
                                    </Col>

                            </Descriptions.Item>
                        </Descriptions>
                    }
                    {currentUser.cliente.modules.includes('OFCTO') &&
                        <Descriptions layout="horizontal" bordered>
                            <Descriptions.Item
                                label={<b>{t("messages.aml.modulesNames.complianceOfficer")}</b>}>
                                    <Select value={selectedUserId}
                                            style={{width: '84%',}}
                                            placeholder={t('messages.aml.select')}
                                            onChange={handleUserChange}>
                                        {usersList.map(user => (user.type === 'SADMIN' || user.type === 'ADMIN' || user.type === 'USUARIO') &&
                                            <Option value={user.id}>{user.name}</Option>)
                                        }
                                    </Select>
                            </Descriptions.Item>
                        </Descriptions>
                    }

                    <Descriptions column={1} layout="horizontal" bordered>
                        <Descriptions.Item label={<b>{t('messages.aml.authorizedIps')}</b>}>
                                <div className="authorized-ips block">
                                    <div className="authorized-ips-inner">
                                        <div className="authorized-ips-header">
                                                <Col span={21}>
                                                {getFieldDecorator('userIp')(
                                                <Input className="user-ip" placeholder={t('messages.aml.enterIpAddress')}/>)}
                                                </Col>
                                                <Col span={1}>
                                                <div className="add-button" onClick={handleAddIp}>
                                                <Icon type="plus"/>
                                                </div>
                                                </Col>

                                                <Col span={1}>
                                                <div className="get-ip-button" onClick={handleGetUserIp}><Icon
                                                type={userIpIsLoading ? 'loading' : 'environment'}/>
                                                </div>
                                                </Col>
                                        </div>
                                        <ul>
                                            {ipsList.map((ip, index) =>
                                                <li key={index}>
                                                    <span className="ip-address">{ip}</span>
                                                    <span className="remove"
                                                          onClick={() => handleRemoveIp(index)}><Icon
                                                          type="close"/>
                                                    </span>
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                        </Descriptions.Item>
                    </Descriptions>

                    <Descriptions column={1} layout="horizontal" bordered>
                        <Descriptions.Item label={<b>Logo Corporativo (máximo 50KB) para Certificados y Página Web</b>}>
                            <div className="authorized-ips block corporate-logos" style={{height: 'unset'}}>
                                <div className="authorized-ips-inner" style={{height: 'unset'}}>
                                    <div className="logos-list-section">
                                        {logos.map((logo) => {
                                            const logoUrl = getLogoUrl(logo)
                                            return (
                                                <div key={logo.id} className="logo-item">
                                                    <span className="logo-preview">
                                                        {logoUrl ? (
                                                            <ImageResources 
                                                                url={logoUrl} 
                                                                styleResource={{ height: '30px', maxWidth: '150px', objectFit: 'contain' }}
                                                            />
                                                        ) : (
                                                            <span className="logo-placeholder">Sin logo</span>
                                                        )}
                                                    </span>
                                                    <span className="logo-label">{logo.name}</span>
                                                    <span className="logo-actions">
                                                        {downloadingLogoId === logo.id ? (
                                                            <Button
                                                                className="download-button"
                                                                icon="loading"
                                                                disabled
                                                            />
                                                        ) : (
                                                            <Tooltip title="Descargar logo">
                                                                <Button
                                                                    className="download-button"
                                                                    icon="cloud-download"
                                                                    onClick={() => handleDownloadLogo(logo)}
                                                                />
                                                            </Tooltip>
                                                        )}
                                                        
                                                        <Upload {...uploadProps(logo)} disabled={uploadingLogoId === logo.id}>
                                                            {uploadingLogoId === logo.id ? (
                                                                <Button
                                                                    className="upload-button"
                                                                    icon="loading"
                                                                    disabled
                                                                />
                                                            ) : (
                                                                <Tooltip title="Actualizar logo">
                                                                    <Button
                                                                        className="upload-button"
                                                                        icon="upload"
                                                                    />
                                                                </Tooltip>
                                                            )}
                                                        </Upload>
                                                    </span>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        </Descriptions.Item>
                    </Descriptions>

                    {currentUser?.cliente?.modules?.includes('REGISTRO') && (
                        <Descriptions column={1} layout="horizontal" bordered>
                            <Descriptions.Item label={<b>Banner inferior Portal de Usuarios (900x120px - máximo 150KB)</b>}>
                                <div className="authorized-ips block corporate-logos banner-section">
                                    <div className="authorized-ips-inner">
                                        <div className="logos-list-section">
                                            <div className="banner-wrapper">
                                                <div className="banner-actions-container">
                                                    <span className="logo-actions banner-actions">
                                                        {downloadingBanner ? (
                                                            <Button
                                                                className="download-button banner-button"
                                                                icon="loading"
                                                                disabled
                                                            >
                                                            </Button>
                                                        ) : (
                                                            <Button
                                                                className="download-button banner-button"
                                                                icon="cloud-download"
                                                                onClick={handleDownloadBanner}
                                                            >
                                                                Descargar Banner
                                                            </Button>
                                                        )}
                                                        
                                                        <Upload {...uploadBannerProps} disabled={uploadingBanner || deletingBanner}>
                                                            {uploadingBanner ? (
                                                                <Button
                                                                    className="upload-button banner-button"
                                                                    icon="loading"
                                                                    disabled
                                                                >
                                                                </Button>
                                                            ) : (
                                                                <Button
                                                                    className="upload-button banner-button"
                                                                    icon="upload"
                                                                    disabled={deletingBanner}
                                                                >
                                                                    Actualizar Banner
                                                                </Button>
                                                            )}
                                                        </Upload>
                                                    </span>
                                                </div>
                                                <div className="banner-preview-container" style={{ marginTop: '15px', textAlign: 'center' }}>
                                                    {hasBanner && (
                                                        deletingBanner ? (
                                                            <Icon 
                                                                type="loading" 
                                                                className="banner-delete-icon"
                                                            />
                                                        ) : (
                                                            <Icon 
                                                                type="close-circle" 
                                                                className="banner-delete-icon"
                                                                onClick={handleDeleteBanner}
                                                            />
                                                        )
                                                    )}
                                                    <ImageResources 
                                                        url={`/portal/getLogoFooterPortal/${currentUser.cliente.id}?t=${refreshKey}`}
                                                        styleResource={{ width: '100%', maxWidth: '900px', maxHeight: '120px', objectFit: 'contain' }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Descriptions.Item>
                        </Descriptions>
                    )}
                </>
                :
                <Spin spinning={true} size="large"/>
            }

        </div>
    )
}

export default Form.create()(AdminAuthIps)
